import React from 'react';

interface MyRosterHeaderProps {
  hasImportedSettings: boolean;
  leagueName?: string;
}

export const MyRosterHeader: React.FC<MyRosterHeaderProps> = ({
  hasImportedSettings,
  leagueName
}) => {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:mb-8 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h1 className="font-display text-2xl font-semibold tracking-tight text-white sm:text-3xl">
          My Roster
        </h1>
        <p className="mt-1 max-w-xl text-sm text-zinc-500">
          Your team on this board, plus weekly notes from the live web.
        </p>
      </div>
      {hasImportedSettings && leagueName ? (
        <div className="inline-flex items-center self-start rounded-full border border-white/10 px-2.5 py-1 sm:self-auto">
          <div className="mr-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-fiesta-yellow" />
          <span className="max-w-[10rem] truncate text-xs text-zinc-400">
            {leagueName}
          </span>
        </div>
      ) : null}
    </div>
  );
};
